interface SEOConfig {
  title: string;
  description: string;
  keywords?: string;
  ogType?: string;
}

interface SEOConfigMap {
  [key: string]: SEOConfig;
}

export const seoConfig: SEOConfigMap = {
  '/': {
    title: 'Gelwel — Social & Lifestyle App for Real Connections',
    description: 'Meet people who match your vibe. Gelwel combines lifestyle, AI, and social features into one sleek app.',
    keywords: 'social app, lifestyle app, meet people, real connections, AI matching, vibe matching, social networking, lifestyle community',
    ogType: 'website',
  },
  '/contact': {
    title: 'Contact Us | Gelwel',
    description: 'Get in touch with the Gelwel team. We\'re here to help with any questions or feedback about our social and lifestyle app.',
    keywords: 'contact gelwel, gelwel support, customer service, feedback, help',
    ogType: 'website',
  },
  '/policies': {
    title: 'Policies | Gelwel',
    description: 'Review Gelwel\'s policies including privacy, terms of use, security, and community guidelines.',
    keywords: 'gelwel policies, app policies, terms and conditions, privacy policy',
    ogType: 'website',
  },
  '/privacy': {
    title: 'Privacy Policy | Gelwel',
    description: 'Learn how Gelwel protects your privacy and handles your personal data. Read our comprehensive privacy policy.',
    keywords: 'privacy policy, data protection, personal information, GDPR, privacy rights',
    ogType: 'article',
  },
  '/terms': {
    title: 'Terms of Use | Gelwel',
    description: 'Read Gelwel\'s terms of use and understand your rights and responsibilities when using our social and lifestyle app.',
    keywords: 'terms of use, terms and conditions, user agreement, legal terms',
    ogType: 'article',
  },
  '/cookies': {
    title: 'Cookie Policy | Gelwel',
    description: 'Understand how Gelwel uses cookies to enhance your experience and what choices you have regarding cookies.',
    keywords: 'cookie policy, cookies, tracking, web cookies, cookie consent',
    ogType: 'article',
  },
  '/consent': {
    title: 'Consent Policy | Gelwel',
    description: 'Learn about Gelwel\'s consent practices and how we obtain and manage your permissions.',
    keywords: 'consent policy, user consent, data consent, permission management',
    ogType: 'article',
  },
  '/security': {
    title: 'Security Policy | Gelwel',
    description: 'Discover how Gelwel keeps your account and data secure with industry-leading security measures.',
    keywords: 'security policy, data security, account security, encryption, cybersecurity',
    ogType: 'article',
  },
  '/community-policies': {
    title: 'Community Policies | Gelwel',
    description: 'Read Gelwel\'s community guidelines and learn how we maintain a safe, respectful environment for all users.',
    keywords: 'community policies, community guidelines, code of conduct, user behavior, moderation',
    ogType: 'article',
  },
  '/account-support': {
    title: 'Account Support | Gelwel',
    description: 'Need help with your Gelwel account? Find answers to common questions and learn how to manage your account.',
    keywords: 'account support, help center, account management, troubleshooting, FAQs',
    ogType: 'website',
  },
};

export const getSEOConfig = (pathname: string): SEOConfig => {
  return seoConfig[pathname] || seoConfig['/'];
};
